import themeConfig from '../../../theme.config'
import { HomeIcon } from '@heroicons/react/24/solid'

function Breadcrumbs(props) {
  if (!props.items?.length) {
    return
  }
  return (
    <nav aria-label="breadcrumb navigation" className="max-md:hidden">
      <ul
        className={`bg-${themeConfig.settings.nav.breadcrumbs.base} border-y-2 border-gray-200 text-${themeConfig.settings.nav.breadcrumbs.base}-text -xs font-medium flex`}
      >
        {props.items.map((item, i) => (
          <li key={i} className="flex">
            {item.disablePageLinkInMegaMenu && <span className="block px-4 py-3 flex items-center ">{item.label}</span>}
            {!item.disablePageLinkInMegaMenu && (
              <a href={item.url} className={`px-4 py-3 flex items-center hover:underline ${i == 0 ? 'pl-6' : ''}`}>
                {i === 0 && (
                  <>
                    <HomeIcon
                      className={`h-6 w-6 text-${themeConfig.settings.nav.breadcrumbs.base}-text`}
                      aria-label="Home"
                      role="none"
                    />
                    <span className="sr-only">Home</span>
                  </>
                )}
                {i > 0 && item.label}
              </a>
            )}
            {i != props.items.length - 1 && (
              <svg
                className="h-full w-6 flex-shrink-0 text-brightgrey-50"
                viewBox="0 0 24 44"
                preserveAspectRatio="none"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
              </svg>
            )}
          </li>
        ))}
      </ul>
    </nav>
  )
}

export default Breadcrumbs
